import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Form, Input, Select } from 'antd'
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'react-addons-update';
import './excellentCourse.less'
const { Option } = Select
let dragingIndex = -1;
class BodyRow extends React.Component {
	render() {
		const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
		const style = { ...restProps.style, cursor: 'move' };

		let { className } = restProps;
		if (isOver) {
			if (restProps.index > dragingIndex) {
				className += ' drop-over-downward';
			}
			if (restProps.index < dragingIndex) {
				className += ' drop-over-upward';
			}
		}

		return connectDragSource(
			connectDropTarget(<tr {...restProps} className={className} style={style} />),
		);
	}
}
const rowSource = {
	beginDrag(props) {
		dragingIndex = props.index;
		return {
			index: props.index,
		};
	},
};
const rowTarget = {
	drop(props, monitor) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;
		if (dragIndex === hoverIndex) {
			return;
		}
		console.log('dragIndex', dragIndex)
		console.log('hoverIndex', hoverIndex)

		props.moveRow(dragIndex, hoverIndex);
		monitor.getItem().index = hoverIndex;
	},
};
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
}))(
	DragSource('row', rowSource, connect => ({
		connectDragSource: connect.dragSource(),
	}))(BodyRow),
);
class ExcellentCourse extends Component {
	constructor(props) {
		super(props)
		this.state = {
			hot: undefined,
			courseType: 3,
			total: 0,
			strageId: '',
			modelTitle: '新增精品课',
			visible: false,
			releaseVisible: false,
			strageName:'',
			changeSwitch: false,
			name: '',
			searchData: {
				pageNum: 1,
				pageSize: 20
			},
			columns: [
				{
					title: '课程名称',
					dataIndex: 'name',
					key: 'name',
					align: 'center',
					ellipsis: true,
					// render: (record)=> <span style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',maxWidth: '160px'}}>{record}</span>
				},
        {
					title: '课程标签',
					dataIndex: 'label',
					key: 'label',
					align: 'center'
				},
        {
					title: '章节数量',
					dataIndex: 'num',
					key: 'num',
					align: 'center'
				},
				{
					title: '热门课程',
					dataIndex: 'hot',
					key: 'hot',
					align: 'center',
					render: (record)=> <span>{record===1? '是': '否'}</span>
				},
				{
					title: '创建人',
					dataIndex: 'admin',
					key: 'admin',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							sessionStorage.setItem('courseType','modify')
							sessionStorage.setItem('courseId', record.id)
							this.props.history.push('/AddExcellentCourse')
						}}>编辑</span>
						<span style={{marginRight:'15px',color: '#277FFF', cursor: 'pointer'}} onClick={()=>{
							sessionStorage.setItem('courseId', record.id)
							this.props.history.push('/Catalogue')
						}}>目录</span>
						<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除精品课',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p>精品课删除后不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delStage(record.id)
								},
							});
						}}>删除</span>
					</div>
				},
			],
			courseListData: [],
			notChanged: []

		}
	}
  // 列表查询
	async getStageList() {
		axios.post('courseController/getList', {
			subjectId:sessionStorage.getItem('subjectId'),
			...this.state.searchData,
			name: this.state.name,
			type: this.state.courseType,
			hot: this.state.hot
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					total: res.data.data.total,
					courseListData: res.data.data.list,
					notChanged: res.data.data.list,
					searchData: {
						pageNum: res.data.data.pageNum,
						pageSize: res.data.data.pageSize
					}
				})
			}
		})
	}

  // 删除
	delStage(id) {
		axios.get(`courseController/del/${id}`).then(res => {
			if(res.data.code === '200') {
				message.success('删除课程成功')
				this.getStageList()
			}else {
				message.success(res.data.msg)
			}
		})
	}
	
	componentDidMount() {
		this.getStageList()
	}
	components = {
		body: {
			row: DragableBodyRow,
		},
	};
	moveRow = (dragIndex, hoverIndex) => {
		const { courseListData } = this.state;
		const dragRow = courseListData[dragIndex];
		this.setState(
			update(this.state, {
				courseListData: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
		let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.courseListData[i].id })
		}
		axios.post('courseController/updateSort',oldSort).then(res => {
			if(res.data.code === '200' )
			oldSort = []
		})
		

	};
	render() {
		const { columns, courseListData, total } = this.state;
		const pagination = {
			showSizeChanger: true,
			total: total,
			pageSize: this.state.searchData.pageSize,
			pageSizeOptions: ['20', '40', '80', '200'],
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.getStageList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.getStageList(searchData)
			},
		}
		return (
			<div className="course">
				<div style={{display: 'flex',justifyContent: 'space-between'}}>
					<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>精品课管理</span>
					<span className="my-button-txt" onClick={()=> {
						sessionStorage.setItem('courseType','')
						sessionStorage.setItem('courseId','')
						this.props.history.push('/subjectController')
					}}>返回上一级</span>
				</div>
				
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						<Input allowClear value={this.state.name} style={{ width: '260px', height: '40px', marginRight: '20px' }} 
						placeholder="请输入精品课名称"
						onChange={(e)=>{
							this.setState({
									name: e.target.value
							})
						}}
						/>
						<Select  placeholder="热门课程" value={this.state.hot} allowClear style={{ width: 160, height: '40px' }} onChange={(value)=>{
							this.setState({
								hot: value
							})
						}}>
							<Option value="1">是</Option>
							<Option value="0">否</Option>
						</Select>
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.getStageList()
						}}>搜索</Button>
						<span className="my-button-txt" style={{marginLeft: '20px'}} onClick={()=> {
							this.setState({name: '',hot: undefined,courseType: 3},()=> {
								this.getStageList()
							})
						}}>重&nbsp;置</span>
					</div>
					<Button className='my-button-primary' type='primary' onClick={() => {
						sessionStorage.setItem('courseType','add')
						this.props.history.push('/AddExcellentCourse')
					 }}>新增精品课</Button>
				</div>
				<DndProvider backend={HTML5Backend}>
					<Table
						dataSource={courseListData}
						columns={columns}
						components={this.components}
						rowKey={record => record.id}
						rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
						onRow={(record, index) => ({
							index,
							moveRow: this.moveRow,
						})}
						pagination={pagination}
					/>
				</DndProvider>
			</div>
		)
	}
}

export default Form.create()(ExcellentCourse)